export default __webpack_public_path__ + "static/media/dieppe23.bdee7f6d.jpg";